"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.sizing = void 0;
const utils_1 = require("../utils");
exports.sizing = {
    sizeSpaceNone: (0, utils_1.designToken)('0px'),
    sizeSpaceXXS: (0, utils_1.designToken)('2px'),
    sizeSpaceXS: (0, utils_1.designToken)('4px'),
    sizeSpaceS: (0, utils_1.designToken)('8px'),
    sizeSpaceM: (0, utils_1.designToken)('16px'),
    sizeSpaceL: (0, utils_1.designToken)('24px'),
    sizeSpaceXL: (0, utils_1.designToken)('32px'),
    sizeSpaceXXL: (0, utils_1.designToken)('48px'),
    sizeSpaceXXXL: (0, utils_1.designToken)('64x'),
    sizeNone: (0, utils_1.designToken)('0px'),
    sizeXXS: (0, utils_1.designToken)('2px'),
    sizeXS: (0, utils_1.designToken)('4px'),
    sizeS: (0, utils_1.designToken)('8px'),
    sizeM: (0, utils_1.designToken)('16px'),
    sizeL: (0, utils_1.designToken)('24px'),
    sizeXL: (0, utils_1.designToken)('32px'),
    sizeXXL: (0, utils_1.designToken)('48px'),
    sizeXXXL: (0, utils_1.designToken)('64x'),
    sizeFieldNone: (0, utils_1.designToken)('0px'),
    sizeFieldXXS: (0, utils_1.designToken)('80px'),
    sizeFieldXS: (0, utils_1.designToken)('128px'),
    sizeFieldS: (0, utils_1.designToken)('176px'),
    sizeFieldM: (0, utils_1.designToken)('272px'),
    sizeFieldL: (0, utils_1.designToken)('368px'),
    sizeFieldXL: (0, utils_1.designToken)('464px'),
    sizeFieldXXL: (0, utils_1.designToken)('560px'),
    sizeDialogWidthXXS: (0, utils_1.designToken)('288px'),
    sizeDialogWidthXS: (0, utils_1.designToken)('480px'),
    sizeDialogWidthS: (0, utils_1.designToken)('600px'),
    sizeDialogWidthM: (0, utils_1.designToken)('720px'),
    sizeDialogWidthL: (0, utils_1.designToken)('800px'),
    sizeDialogWidthXL: (0, utils_1.designToken)('880px'),
    sizeDialogWidthXXL: (0, utils_1.designToken)('960px'),
    sizeDialogHeightXXS: (0, utils_1.designToken)('160px'),
    sizeDialogHeightXS: (0, utils_1.designToken)('260px'),
    sizeDialogHeightS: (0, utils_1.designToken)('320px'),
    sizeDialogHeightM: (0, utils_1.designToken)('400px'),
    sizeDialogHeightL: (0, utils_1.designToken)('432px'),
    sizeDialogHeightXL: (0, utils_1.designToken)('560px'),
    sizeDialogHeightXXL: (0, utils_1.designToken)('700px'),
    font: (0, utils_1.designToken)('400 13px/16px "Open Sans", sans-serif'),
    fontFamily: (0, utils_1.designToken)('"Open Sans", sans-serif'),
    fontSizeS: (0, utils_1.designToken)('12px'),
    fontSizeM: (0, utils_1.designToken)('13px'),
    fontSizeL: (0, utils_1.designToken)('15px'),
    fontSizeXL: (0, utils_1.designToken)('21px'),
    lineHeightS: (0, utils_1.designToken)('14px'),
    lineHeightM: (0, utils_1.designToken)('16px'),
    lineHeightL: (0, utils_1.designToken)('18px'),
    lineHeightXL: (0, utils_1.designToken)('26px'),
    fontWeightLighter: (0, utils_1.designToken)('200'),
    fontWeightNormal: (0, utils_1.designToken)('400'),
    fontWeightSemiBold: (0, utils_1.designToken)('600'),
    fontWeightBold: (0, utils_1.designToken)('700'),
    boxShadowS: (0, utils_1.designToken)('2px 2px 5px rgba(0, 0, 0, 0.2)'),
    borderWidthNone: (0, utils_1.designToken)('0px'),
    borderWidthS: (0, utils_1.designToken)('1px'),
    borderRadiusNone: (0, utils_1.designToken)('0px')
};
//# sourceMappingURL=sizing.js.map